import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getLinkDataInSelection, scrollToBlock } from 'wix-rich-content-editor-common';
import { s as styles } from '../link-viewer-68944646.js';
import { mergeStyles, normalizeHref, getRelValue } from 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class UrlLinkButton extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleClick", (event) => {
      const { getEditorState, customAnchorScroll } = this.props;
      const linkData = getLinkDataInSelection(getEditorState());
      const { anchor = "" } = linkData || {};
      if (customAnchorScroll) {
        customAnchorScroll(event, anchor);
      } else {
        scrollToBlock(anchor);
      }
    });
    __publicField(this, "preventDefault", (event) => event.preventDefault());
    const { theme } = this.props;
    this.styles = mergeStyles({ styles, theme });
  }
  render() {
    const { styles: styles2 } = this;
    const { getEditorState, t } = this.props;
    const linkData = getLinkDataInSelection(getEditorState());
    const { url = "", anchor, target, rel } = linkData || {};
    const href = url ? normalizeHref(url) : void 0;
    const anchorProps = {
      href,
      target,
      rel: getRelValue(rel),
      className: classNames(styles2.toolbarUrl, { [styles2.toolbarUrlAnchor]: anchor }),
      onMouseDown: this.preventDefault,
      onClick: anchor && this.handleClick
    };
    return /* @__PURE__ */ React.createElement("div", { className: styles2.toolbarUrlContainer }, /* @__PURE__ */ React.createElement("a", __spreadValues({}, anchorProps), href || t("LinkTo_Toolbar_GoTo")));
  }
}
UrlLinkButton.propTypes = {
  getEditorState: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  customAnchorScroll: PropTypes.func,
  settings: PropTypes.object,
  t: PropTypes.func
};

export { UrlLinkButton as default };
//# sourceMappingURL=UrlLinkButton.js.map
